import { useUserFactsStore } from '@/Stores/Web/userFactsStore.js';

const followActionNames = ['followUser', 'unfollowUser'];

// Call in setup() so Pinia ties the $onAction subscription to the component's
// effect scope (auto-disposed on unmount). Returns a register function to set
// the handler from created(), where the component instance/methods are available.
export function useFollowActionSubscription() {
    const userFactsStore = useUserFactsStore();
    let handler = null;

    userFactsStore.$onAction((action) => {
        if (followActionNames.includes(action.name)) {
            handler?.(action);
        }
    });

    return (onFollowAction) => {
        handler = onFollowAction;
    };
}
